var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57242 9.98634C8.6361 10.8236 7.41298 11.3304 6.07486 11.3304C3.12945 11.3304 0.741699 8.8748 0.741699 5.84562C0.741699 2.81644 3.12945 0.360809 6.07486 0.360809C9.02028 0.360809 11.408 2.81644 11.408 5.84562C11.408 6.98878 11.0681 8.05027 10.4863 8.92891L16.7417 15.3622L15.7707 16.3608L9.57242 9.98634ZM10.0349 5.84562C10.0349 8.09487 8.26197 9.91825 6.07486 9.91825C3.88776 9.91825 2.11484 8.09487 2.11484 5.84562C2.11484 3.59637 3.88776 1.77299 6.07486 1.77299C8.26197 1.77299 10.0349 3.59637 10.0349 5.84562Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.986b46cdbb91cad78cfaa75511826ead.svg";
export { ForwardRef as ReactComponent };